import { ReportSummaryRow, ClassRow } from './reports-model';
import { utils } from '@bayclubs/utils';

export class AttendanceClassItem extends ClassRow {
    costPerHead: number;
    instructorName: string;
    instructorId: string;
}

export class AttendanceDateSummary extends ReportSummaryRow {
    classes: AttendanceClassItem[];
    constructor(public date: utils.BcDate) {
        super();
        this.classes = [];
        this.totalCost = 0;
        this.totalHours = 0;
    }
}

export class AttendanceFilters {
    constructor(public className: string, public instructors: string[]) {}
}
